(function () {
    "use strict";
    var t,
        e = {
            4105: function (t, e, n) {
                n.d(e, {
                    Q2: function () {
                        return o;
                    },
                    gp: function () {
                        return window.gp;  // Exposing gp globally
                    },
                    hO: function () {
                        return window.hO;  // Exposing hO globally
                    }
                });

                // Define Q2 function and attach it to the global window object
                const o = function () {
                    return {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Accept: `application/${
                                arguments.length > 0 && void 0 !== arguments[0]
                                    ? arguments[0]
                                    : "json"
                            }`
                        }
                    };
                };

                window.Q2 = o; // Make Q2 globally accessible

                window.hO = function () {
                    let t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    const e = window.innerWidth - document.body.offsetWidth,
                        n = document.getElementById("nav-wrapper");
                    t
                        ? (document.body.classList.add("no-scroll"),
                          (document.body.style.paddingRight = e + "px"),
                          (n.style.paddingRight = e + "px"))
                        : (document.body.classList.remove("no-scroll"),
                          (document.body.style.paddingRight = "0px"),
                          (n.style.paddingRight = "0px"));
                };

                let a = () => {};
                const c = (t) => {
                        "Escape" === t.key &&
                            (a(), window.removeEventListener("keydown", c));
                    },
                    s = function () {
                        let t =
                                arguments.length > 0 &&
                                void 0 !== arguments[0] &&
                                arguments[0],
                            e = arguments.length > 1 ? arguments[1] : void 0;
                        e && (a = e),
                            t
                                ? window.addEventListener("keydown", c)
                                : window.removeEventListener("keydown", c);
                    };

                window.gp = function () {
                    let t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                        e = arguments.length > 1 ? arguments[1] : void 0;
                    e && (a = e),
                    t
                        ? window.addEventListener("keydown", c)
                        : window.removeEventListener("keydown", c);
                };

                document.querySelectorAll(".local-scroll").forEach((t) => {
                    t.addEventListener("click", (t) => {
                        t.preventDefault();
                        t.stopPropagation();
                        const e = t.target.getAttribute("href");

                        const element = document.querySelector(e);
                        
                        if (element) {
                            Math.easeInOutQuad = function (t, e, n, o) {
                                return (t /= o / 2) < 1
                                    ? (n / 2) * t * t + e
                                    : (-n / 2) * (--t * (t - 2) - 1) + e;
                            };

                            const header = document.getElementById("grid-archive-header");
                            const navWrapper = document.getElementById("nav-wrapper");

                            let offsetHeader = 0,
                                offsetNavWrapper = 0;

                            if (header) offsetHeader = header.offsetHeight + 50;
                            if (navWrapper) offsetNavWrapper = navWrapper.offsetHeight + 50;

                            const targetPosition = element.offsetTop - offsetHeader - offsetNavWrapper;
                            const currentPosition = window.scrollY;
                            const scrollDistance = targetPosition - currentPosition;

                            let i = 0;
                            const scrollToPosition = () => {
                                i += 5;
                                const position = Math.easeInOutQuad(i, currentPosition, scrollDistance, 200);
                                window.scrollTo(0, position);
                                if (i < 200) setTimeout(scrollToPosition, 5);
                            };

                            scrollToPosition();
                        }
                    });
                });
            }
        },
        n = {};

    function o(t) {
        var r = n[t];
        if (void 0 !== r) return r.exports;
        var a = (n[t] = {
            exports: {}
        });
        return e[t](a, a.exports, o), a.exports;
    }

    o.d = function (t, e) {
        for (var n in e)
            o.o(e, n) &&
                !o.o(t, n) &&
                Object.defineProperty(t, n, {
                    enumerable: !0,
                    get: e[n]
                });
    };
    o.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
    };

    t = o(4105);

    (() => {
        const e = document.querySelectorAll('form[action="/cart/add"]'),
            n = document.getElementById("main-cart"),
            o = document.getElementById("overlay"),
            r = document.getElementById("mini-cart"),
            a = document.querySelector("cart-service"),
            c = document.querySelector("body"),
            s = () => {
                r.classList.remove("open"),
                    o.classList.remove("open"),
                    c.style.removeProperty("overflow"),
                    window.hO(!1);
            };

        e.length &&
            e.forEach((form) => {
                form.addEventListener("submit", async (event) => {
                    event.preventDefault();

                    const submitButton = event.target.querySelector(
                        'button[type="submit"]'
                    );
                    const buttonText = submitButton.querySelector(
                        "span:not(.cart-icon):not(:empty)"
                    );
                    const cartIcon = submitButton.querySelector(
                        "span.cart-icon"
                    );
                    const loadingIcon = submitButton.querySelector(
                        "svg.loading-icon"
                    );
                    const errorContainer = event.target.querySelector(
                        ".product-converter__error"
                    );

                    if (buttonText)
                        buttonText.textContent = cartStrings.addingToCart;
                    submitButton.classList.add("added");
                    cartIcon.style.display = "none";
                    loadingIcon.style.display = "block";

                    const requestOptions = window.Q2("javascript"); // Using Q2 globally
                    requestOptions.headers["X-Requested-With"] =
                        "XMLHttpRequest";
                    delete requestOptions.headers["Content-Type"];

                    const formData = new FormData(form);
                    formData.append("sections", "main-cart");
                    requestOptions.body = formData;

                    try {
                        const response = await fetch(
                            routes.cartAdd,
                            requestOptions
                        );
                        const result = await response.json();

                        cartIcon.style.display = "inline-flex";
                        loadingIcon.style.display = "none";
                        submitButton.classList.remove("added");

                        if (result.status) {
                            if (buttonText)
                                buttonText.textContent = cartStrings.addToCart;
                            errorContainer.innerHTML = `<span class="icon loaded">error</span><p>${
                                typeof result.description === "object"
                                    ? Object.values(result.description).join(
                                          ", "
                                      )
                                    : result.description
                            }</p>`;
                        } else {
                            if (cartStrings.uxCart === "cart") {
                                window.location.href = routes.cart;
                                return;
                            }

                            errorContainer.innerHTML = "";
                            n && n.classList.add("added");
                            a.renderItems(
                                new DOMParser().parseFromString(
                                    result.sections["main-cart"],
                                    "text/html"
                                )
                            );

                            if (cartStrings.uxCart === "mini-cart") {
                                r && r.classList.add("open");
                                o && o.classList.add("open", "overlay--all");
                                window.hO(!0);  // Calling hO globally
                                window.gp(!0, s);  // Calling gp globally
                            }

                            if (buttonText)
                                buttonText.textContent = cartStrings.addedToCart;
                            submitButton.classList.add("successful");
                        }
                    } catch (error) {
                        console.error("Error adding to cart:", error);
                        cartIcon.style.display = "inline-flex";
                        loadingIcon.style.display = "none";
                        if (buttonText)
                            buttonText.textContent = cartStrings.addToCart;
                    }
                });
            });
    })();
})();
